import { Field, Switch, Tooltip } from '@payaca/ambrosia';
import { FC } from 'react';

export type TProps = {
  /** react-hook-form field name, so validation errors display. */
  name: string;
  label: string;
  /** Longer explanation, shown on hover/focus of the Switch. */
  tooltip: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
};

/** A Switch beside its label, with the longer explanation in a tooltip. */
const InlineSwitchField: FC<TProps> = (props) => {
  const { name, label, tooltip, value, onChange, disabled } = props;

  return (
    <Field className="flex items-center gap-2.5 space-y-0" name={name}>
      <Tooltip className="flex" tooltipContent={tooltip}>
        <Switch value={value} onChange={onChange} disabled={disabled} />
      </Tooltip>

      <Field.Label>{label}</Field.Label>
    </Field>
  );
};

export default InlineSwitchField;
